export const onPressEnter = (cb) => (e) => {
  if (e.key === 'Enter') {
    e.preventDefault()
    cb(e)
  }
}
